import Vue from 'vue'
import Router from 'vue-router'
import {mainStore} from '../stores/index.js';
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

const CustomerList = () => import('@/views/customers/CustomerList');
const CustomerModules = () => import('@/views/customers/CustomerModules');
const CreateProject = () => import('@/views/customers/CreateProject');
const CreateOffice = () => import('@/views/customers/CreateOffice');
const CompanyGroupList = () => import("@/views/customers/CompanyGroupList");
const CompanyList = () => import("@/views/customers/CompanyList");
const EditCompany = () => import("@/views/customers/EditCompany");

const BillingSetup = () => import('@/views/billings/Setup');
const Invoice = () => import('@/views/billings/Invoice');
const Payment = () => import('@/views/billings/Payment');
const DueStatus = () => import('@/views/billings/DueStatus');

const Version = () => import('@/views/settings/Version');
const Module = () => import('@/views/settings/Module');
const VersionConfigurator = () => import('@/views/settings/VersionConfigurator')
// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');

//Views - Resellers
const ResellerList = () => import('@/views/resellers/ResellerList');
const ViewReseller = () => import('@/views/resellers/ViewReseller');

//Views - Orders
const PurchaseOrderList = () => import('@/views/orders/PurchaceOrderList');
const CreatePurchaseOrder = () => import('@/views/orders/CreatePurchaseOrder');
const CreateDeliveryReceipt = () => import("@/views/orders/CreateDeliveryReceipt");
const ViewDeliveryDetails = () => import("@/views/orders/ViewDeliveryDetails");
const EditPurchaseOrder = () => import("@/views/orders/editPurchaseOrder");

// Users
const Users = () => import('@/views/users/Users');
const User = () => import('@/views/users/User');

// Customer Support
const PasswordReset = () => import('@/views/customerSupport/PasswordReset');
const SupportManagement = () => import("@/views/customerSupport/SupportManagement");
const CloneTemporaryAllocations = () => import("@/views/customerSupport/CloneTemporaryAllocations");
const ArchivedReportDownload = () => import("@/views/customerSupport/ArchivedReportDownload")
//Payroll
const PayrollManager = () => import('@/views/payroll/PayrollManager');

// ProvidentFund
const ProvidentFund = () => import('@/views/payroll/ProvidentFund');

//General Settings
const MobilePunchGeneralSettings = () => import("@/views/generalSettings/MobilePunchGeneralSettings")
const FiscalYearGeneralSettings = () => import("@/views/generalSettings/FiscalYearGeneralSettings")

const ReportSettingsGeneralSettings = () => import("@/views/generalSettings/ReportSettingsGeneralSettings")
const AttendanceSettings = () => import("@/views/generalSettings/AttendanceSettings")

const ParkingManagementGeneralSettings = () => import("@/views/generalSettings/ParkingManagementGeneralSettings")

const MembershipManagementGeneralSettings = () => import("@/views/generalSettings/MembershipManagementGeneralSettings")

const SiteManagementGeneralSettings = () => import("@/views/generalSettings/SiteManagementGeneralSettings")

const LineManagerSettings = ()=>import("@/views/generalSettings/LineManagerSettings.vue")

const OvertimeGeneralSettings = () => import("@/views/generalSettings/OvertimeGeneralSettings");

const LocationTrackingGeneralSettings = () => import("@/views/generalSettings/LocationTrackingGeneralSettings");

const EmployeeDeviceLimitsSettings = () => import("@/views/generalSettings/EmployeeDeviceLimitsSettings");

const SubscriptionRequestList = () => import("@/views/subscription/SubscriptionRequestList");

Vue.use(Router);

function guard(to, from, next) {
	if (to.name === "Login") {
		next();
		return;
	}

	if (!mainStore.getters.loggedIn) {
		next({ name: "Login" });
	}

	next();
}

const router = new Router({
	mode: 'history', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'open active',
	scrollBehavior: () => ({y: 0}),
	routes: [
		{
			path: '/',
			redirect: '/dashboard',
			name: 'Home',
			component: DefaultContainer,
			children: [
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard
				},
				{
					path: 'customers',
					redirect: '/customers/list',
					name: 'Customer',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'list',
							name: 'List',
							component: CustomerList
						},
						{
							path: 'modules',
							name: 'Modules',
							component: CustomerModules
						},
						{
							path: 'create-project',
							name: 'Create project',
							component: CreateProject
						},
						{
							path: 'create-office',
							name: 'Create Office',
							component: CreateOffice
						},
						{
							path: 'company-groups',
							name: 'Group of Companies',
							component: CompanyGroupList
						},
						{
							path: 'companies',
							name: 'Companies',
							component: CompanyList
						},
						{
							path: 'companies/:companyId',
							name: 'Edit Company',
							component: EditCompany
						},


					]
				},
				{
					path: 'customer-support',
					redirect: '/customer-support/password-reset',
					name: 'Support-Management',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'password-reset',
							name: 'Password Reset',
							component: PasswordReset
						},
						{
							path: 'support-management',
							name: 'Customer Support Management',
							component: SupportManagement
						},
						{
							path: 'temporary-allocations/clone',
							name: 'Clone Temporary Allocations',
							component: CloneTemporaryAllocations
						},
						{
							path: 'report-archive',
							name: 'Report Archive',
							component: ArchivedReportDownload
						}
					]
				},
				{
					path: 'payroll',
					redirect: '/payroll-manager',
					name: 'Payroll',
					component: {
						render(c) {
							return c('router-view');
						}
					},
					children: [
						{
							path: 'payroll-manager',
							name: 'Payroll Manager',
							component: PayrollManager
						},
						{
							path: 'provident-fund',
							name: 'Provident Fund',
							component: ProvidentFund
						},

					]
				},
				{
					path: 'billings',
					redirect: '/billings/setup',
					name: 'Billings',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'setup',
							name: 'Billing Setup',
							component: BillingSetup
						},
						{
							path: 'invoice',
							name: 'Invoice',
							component: Invoice
						},
						{
							path: 'payment',
							name: 'Payment',
							component: Payment
						},
						{
							path : 'due-status',
							name : 'Due Status',
							component : DueStatus
						}
					]
				},
				{
					path: 'settings',
					redirect: '/settings/version',
					name: 'Settings',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'version',
							name: 'Version',
							component: Version
						},
						{
							path: 'module',
							name: 'Module',
							component: Module
						},
						{
							path: 'configurator',
							name: 'VersionConfigurator',
							component: VersionConfigurator
						}
					]
				},
				{
					path: 'resellers',
					redirect: '/resellers/list',
					name: 'Reseller',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'list',
							name: 'Reseller List',
							component: ResellerList
						},
						{
							path: ':resellerId',
							name: 'Reseller Details',
							component: ViewReseller
						}
					]
				},
				{
					path: 'purchase-orders',
					redirect: '/purchase-orders/list',
					name: 'Purchase Order',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'list',
							name: 'P.O. List',
							component: PurchaseOrderList
						},
						{
							path: 'create',
							name: 'Create P.O.',
							component: CreatePurchaseOrder
						},
						{
							path: 'delivery-receipts/create',
							name: 'Create Delivery Receipt',
							component: CreateDeliveryReceipt
						},
						{
							path: ':purchaseOrderId',
							name: 'Delivery Details',
							component: ViewDeliveryDetails
						},
						{
							path: 'edit/:purchaseOrderId',
							name: 'Edit P.O.',
							component: EditPurchaseOrder
						}
					]
				},
				{
					path: 'users',
					meta: {label: 'Users'},
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: '',
							component: Users,
						},
						{
							path: ':id',
							meta: {label: 'User Details'},
							name: 'User',
							component: User,
						},
					]
				},
				{
					path: 'general-settings',
					redirect: '/general-settings/mobile-punch',
					name: 'GeneralSettings',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'mobile-punch',
							name: 'Mobile Punch',
							component: MobilePunchGeneralSettings
						},
						{
							path: 'overtime-settings',
							name: 'Overtime Settings',
							component: OvertimeGeneralSettings
						},
						{
							path: 'fiscal-year',
							name: 'Fiscal Year',
							component: FiscalYearGeneralSettings
						},
						{
							path: 'report-settings',
							name: 'Report Settings',
							component: ReportSettingsGeneralSettings
						},
						{
							path: 'parking-management',
							name: 'Parking Management',
							component: ParkingManagementGeneralSettings
						},
						{
							path: 'membership-management',
							name: 'Membership Management',
							component: MembershipManagementGeneralSettings
						},
						{
							path: 'site-management',
							name: 'Site Management',
							component: SiteManagementGeneralSettings
						},
						{
							path: 'attendance-settings',
							name: 'Attendance Settings',
							component: AttendanceSettings
						},
						{
							path: 'line-manager-settings',
							name: 'Line Manager Settings',
							component: LineManagerSettings
						},
						{
							path: 'location-tracking',
							name: 'Location Tracking',
							component: LocationTrackingGeneralSettings
						},
						{
							path: 'employee-device-limits',
							name: 'Employee and Device Limits',
							component: EmployeeDeviceLimitsSettings
						}
					]
				},
				{
					path: 'subscription',
					redirect: '/subscription/request-list',
					name: 'Subscription',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'request-list',
							name: 'Subscription Request List',
							component: SubscriptionRequestList
						}
					]
				},
			]
		},
		{
			path: '/pages',
			redirect: '/pages/404',
			name: 'Pages',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: '404',
					name: 'Page404',
					component: Page404
				},
				{
					path: '500',
					name: 'Page500',
					component: Page500
				},
			]
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '*',
			redirect: mainStore.getters.loggedIn ? 'dashboard' : 'login'
		},

	]
});
router.beforeEach(guard);

export default router;
